import styled from 'styled-components';

export const ContainerDocumentosSindico = styled.div`
  overflow-y: hidden;
  padding-right: 8px;

  width: 100%;

  height: 100%;
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  min-height: inherit;
  @media (max-width: 1024px) {
    padding-right: 0px;
    height: calc(100vh - 192px);
  }
`;
